<app-select class="validatable-control" [readOnly]="readOnly" label="Category" placeholder="Choose" [items]="categoryItems"
			[formControl]="categoryControl" (click)="controlClicked()" (selectionChange)="categoryChanged($event)">
</app-select>
<app-select class="validatable-control" [readOnly]="readOnly" label="Sub category" placeholder="Choose" [items]="subCategoryItems"
			noItemsMessage="Select a category first" [formControl]="subCategoryControl" (click)="controlClicked()">
</app-select>
@for (formGroup of complicationsArray.controls; track formGroup; let index = $index) {
	<app-textarea hideEmptyValue class="validatable-control" debounce [readOnly]="readOnly" placeholder="Notes..." [label]="formGroup.value.name!"
				  [formControl]="getNotesControl(formGroup)" (click)="controlClicked()" @enterLeave [@.disabled]="readOnly">
		@if (!readOnly) {
			<app-svg-icon class="button" name="close-sharp" (click)="removeComplicationClicked(index)"></app-svg-icon>
		}
	</app-textarea>
}
@if (!readOnly) {
	<app-item class="half-column-gap" (click)="addComplicationClicked()">
		<app-item-value value="Add complication"></app-item-value>
		<app-svg-icon name="add-circle-outline"></app-svg-icon>
	</app-item>
}